module.exports = __webpack_public_path__ + "img/input_off.bf3db6d0.svg";